export const eventTypeLabels: { [key: string]: string } = {
	CartWaitingForApproval: "Approval",
	CartApproved: "Cart Approved",
	CartRejected: "Cart Rejected",

	ShippingInTransit: "Shipping in Transit",
	ShippingInProgress: "Shipping in Progress",
	ShippingCompleted: "Shipping Completed",
	ShippingFailure: "Shipping Failure",

	OrderConfirmation: "Order",
	InvoiceCreated: "Invoice Created",
	ServiceBooking: "Service booking",
};
